<mark [class]="'badge badge-' + type" [matTooltip]="help" [matTooltipDisabled]="!help" [matTooltipShowDelay]="500">
	<ng-content />

	@if (closeItem | hasObservers) {
		<ic-fa-icon
			icon="times"
			[class.close-icon]="!disabled"
			[help]="'actions.delete' | translate"
			(click)="closeItem.emit()"
		/>
	}
</mark>
